<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">About Us</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div v-html="content"></div>

                <a href="http://goldenspoon.co.za/" target="_blank" type="button" class="btn btn-secondary btn-block mb-1">Terms and Conditions</a>
                <a href="http://goldenspoon.co.za/" target="_blank" type="button" class="btn btn-secondary btn-block">Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data: function () {
    return {
      content: ''
    }
  },
  mounted: function () {
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'content/content?content=about_us',
      type: 'get',
      success: function (data) {
        that.content = data.data.copy
      }
    })
  }
}
</script>
